/* eslint-disable @typescript-eslint/naming-convention */
import {Component, OnInit, ChangeDetectionStrategy, OnDestroy} from '@angular/core';
import {FormGroup, FormControl, Validators} from '@angular/forms';
import {Router} from '@angular/router';
import {ROUTE_ANIMATIONS_ELEMENTS} from '@core/animations/route.animations';
import {AuthService} from 'app/auth/auth.service';
import {AuthStateService} from 'app/auth/store/auth.state-service';
import {
  APP_INFO_EMAIL,
  APP_MENU_PRICING,
  APP_PARENT_COMPANY,
  APP_MENU_ADMIN,
  APP_MENU_LOGIN,
  APP_MENU_CONTACT_US,
  APP_TITLE_LONG,
  APP_MENU_CONTACT_US_LINK,
  APP_MENU_LOGIN_LINK,
  APP_MENU_PRICING_LINK,
} from 'app/core/models/common-ux-types';
import {UiStateService} from 'app/core/store/ui/state-service';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HomeComponent implements OnInit, OnDestroy {
  isUserAuthenticated$ = this.authStateService.isUserAuthenticated$;
  isLoading$ = this.uiStateService.isLoading$;
  isMobileDevice$ = this.uiStateService.isMobileDevice$;
  loginForm: FormGroup;
  routeAnimationsElements = ROUTE_ANIMATIONS_ELEMENTS;

  appMenuAdmin = APP_MENU_ADMIN;
  appMenuPricing = APP_MENU_PRICING;
  // APP_MENU_GAME_PLANS = APP_MENU_GAME_PLANS;
  APP_TITLE_LONG = APP_TITLE_LONG;
  appInfoEmail = APP_INFO_EMAIL;
  appParentCompany = APP_PARENT_COMPANY;
  APP_MENU_LOGIN = APP_MENU_LOGIN;
  APP_MENU_CONTACT_US = APP_MENU_CONTACT_US;
  // logo = require('assets/large-logo.jpg').default;
  // intro = require('assets/intro2.jpg').default;

  constructor(
    private authStateService: AuthStateService,
    private uiStateService: UiStateService,
    private router: Router,
    // private recaptcha3: NgRecaptcha3Service,
    private authService: AuthService
  ) {}

  ngOnInit() {
    // console.log('MS HomeComponent');
    // this.recaptcha3.init('6LdX9nUaAAAAADBsCMwEF5EDAEqcIAimkzCsGnyK').then(status => {
    //   // status: success/error
    //   // success - script is loaded and greaptcha is ready
    //   // error - script is not loaded
    //   console.log('MS recaptcha3 status = ', status);
    // });
    this.loginForm = new FormGroup({
      email: new FormControl('', {
        validators: [Validators.required, Validators.email],
      }),
      password: new FormControl('', {validators: [Validators.required]}),
    });
  }
  onLogin() {
    this.router.navigate([`auth/${APP_MENU_LOGIN_LINK}`]);
  }
  onPricing() {
    this.router.navigate([APP_MENU_PRICING_LINK]);
  }

  onContactUs() {
    this.router.navigate([`auth/${APP_MENU_CONTACT_US_LINK}`]);
  }
  ngOnDestroy() {}
}
